import { render, staticRenderFns } from "./VolunteerActivity.vue?vue&type=template&id=2927ad4b"
import script from "./VolunteerActivity.vue?vue&type=script&lang=js"
export * from "./VolunteerActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports